<template>
  <b-modal :visible="show" title="About Runner's High" ok-only ok-title="Close" centered size="sm"
           @show="loadApiRelease" @hidden="$emit('close')">
    <table class="table table-sm table-borderless mb-0">
      <tbody>
      <tr>
        <th class="font-weight-normal text-secondary">Web</th>
        <td>{{ describe(webRelease) }}</td>
      </tr>
      <tr>
        <th class="font-weight-normal text-secondary">API</th>
        <td>
          <b-spinner v-if="apiRelease === null && !apiFailed" small label="Loading"/>
          <span v-else-if="apiFailed" class="text-secondary">Not available</span>
          <template v-else>{{ describe(apiRelease) }}</template>
        </td>
      </tr>
      </tbody>
    </table>
  </b-modal>
</template>

<script>
/**
 * Which releases of the web and the api are running (OSA-131). The image builds set them: the git tag, e.g.
 * 2026.11.04.3, or the branch for other builds, with the commit. Local development shows "development".
 */
export default {
  name: 'AboutBox',
  props: {
    show: Boolean,
  },
  data() {
    return {
      // Built into the bundle by the image build
      webRelease: {
        version: process.env.VUE_APP_VERSION || 'development',
        commit: process.env.VUE_APP_COMMIT || '',
      },
      apiRelease: null,
      apiFailed: false,
    };
  },
  methods: {
    loadApiRelease() {
      // Every time it opens: the api may have been deployed since
      this.apiRelease = null;
      this.apiFailed = false;
      this.$http.get('/api/version')
          .then(response => {
            this.apiRelease = response.data;
          })
          .catch(e => {
            console.warn(e);
            this.apiFailed = true;
          });
    },
    describe(release) {
      return release.commit ? `${release.version} (${release.commit})` : release.version;
    },
  },
}
</script>
